import React from 'react';
import {Provider, observer, inject} from 'mobx-react';
import {IntlProvider} from 'react-intl';
import RootStore from './igsupport_form_components/stores/Root';
import LocaleStore from './common_components/localization/LocaleStore';
import igsupportLocales from '../locales/igsupport.json';
import Form from './igsupport_form_components/Form';

//////// Use Mobx-react-devtools only in development environment ///////////
let DevTools;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    DevTools = require('mobx-react-devtools').default;
} else {
    DevTools = () => null;
}
////////////////////////////////////////////////////////////////////////////


export default class IgSupportForm extends React.Component {

    constructor(props) {
        super(props);
        const localeStore = new LocaleStore(props.user_locale, [igsupportLocales]);
        this.rootStore = new RootStore(props.current_user, localeStore, props.belongs_to_main_startup, props.team);
    }

    render(){
        return(
            <Provider
                rootStore={this.rootStore}
                feedbackChainsStore={this.rootStore.feedbackChainsStore}
                >
                <IntlProvider
                    locale={this.rootStore.localeStore.locale}
                    messages={this.rootStore.localeStore.messages} >
                    <Form />
                </IntlProvider>
            </Provider>
        );
    }
}
